<template lang="pug">
  v-container(:fluid = 'isMobile').storefront
    orderModal( v-if='showCurrentShop' :shop="currentShop")
</template>

<script>
  import orderModal from '@/views/marketplace/components/OrderModal'
  import loaders from '@/plugins/mixins/loaders'
  export default {
    name: 'Shop',

    components: {
      orderModal: orderModal,
    },
    metaInfo () {
      const shop = this.$store.getters['shops/getCurrentShop'] || {}
      const image = shop.img ? shop.img.imageInput1 : ''
      return {
        title: `${shop.name} - TENDER`,
        meta: [
          { name: 'description', content: 'Conectate y sigue ' + shop.name + ' en TENDER' },
          { property: 'og:title', content: shop.name + ' - TenderShop' },
          { property: 'og:site_name', content: shop.name },
          { property: 'og:description', content: shop.description },
          { property: 'og:type', content: 'Tienda virtual - ' + shop.mainCategorie.data },
          { property: 'og:url', content: 'https://admin-tender.web.app/#/shop/' + this.$route.params.name },
          { property: 'og:image', content: image },
        ],
      }
    },
    mixins: [loaders],

    data: () => ({
      // mainBg: require('@/assets/images/background-tender.png'),
      isMobile: false,
      transitionName: null,
      selected: null,
      currentShop: {},
      showCurrentShop: false,
    }),

    computed: {
      /* currentShop () {
        const shop = this.$store.getters['shops/getCurrentShop'] || {}
        // console.log(shop)
        if (shop.id) {
          return {
            category: shop.categories || [],
            data: {
              ...shop,
            },
            id: shop.id,
          }
        } else {
          this.$forceUpdate()
          return null
        }
      }, */
      categories () {
        return this.$store.getters['storefront/getCategories']
      },
    },
    created () {
      const vm = this
      // console.log(this.$route.params.name)
      vm.fetch()
      // console.log(this.$route.params.id)
    },

    mounted () {
      const vm = this
      vm.onResize()
      vm.$forceUpdate()
    },

    methods: {
      fetch () {
        const vm = this
        const shopId = vm.$route.params.name
        vm.$store.dispatch('shops/getVirtualShop', { subdomain: shopId }).then(function (res) {
          if (res && res.status !== 'active') {
            vm.$swal({
              icon: 'error',
              title: 'Ups! Tienda no disponible',
              text: 'Lo sentimos pero esta tienda no se encuentra disponible por el momento',
              showCancelButton: false,
              confirmButtonText: 'Aceptar',
            }).then((result) => {
              vm.$router.replace('/')
            })
          } else if (!res) {
            vm.$swal({
              icon: 'error',
              title: 'Ups! Tienda no disponible',
              text: 'Lo sentimos pero esta tienda no se encuentra disponible por el momento',
              showCancelButton: false,
              confirmButtonText: 'Aceptar',
            }).then((result) => {
              vm.$router.replace('/')
            })
          } else {
            // const shop = vm.$store.getters['shops/getCurrentShop'] || {}
            // console.log(res)
            if (res.id) {
              vm.currentShop = {
                category: res.categories || [],
                data: {
                  ...res,
                },
                id: res.id,
              }
              vm.showCurrentShop = true
            } /* else {
              vm.$forceUpdate()
              vm.currentShop = null
            } */
          }
        })
      },
      onResize () {
        this.isMobile = window.innerWidth < 1024
      },
      swipeHandler (dir) {
        const vm = this
        if (dir === 'left') vm.transitionName = 'slide-left'
        if (dir === 'right') vm.transitionName = 'slide-right'
      },
      goTo (route) {
        const transformRoute = route.split(' ').join('_')
        this.$router.replace(`/store/${transformRoute}`)
      },
    },

  }
</script>
<style scoped lang="scss">
  .selected{
    border-bottom: 2px solid #008e95;
  }
  .category-carousel{
    background: #e3e3e3;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    max-height: 60px;
    width: auto;
    overflow-y: hidden;
    overflow-x: auto;
    padding-left: 10px;
    align-items:center;
    justify-content: space-between;
    padding-bottom: 0;
    &__item{
      text-align: center;
      border-bottom: 2px solid transparent;
      min-width: 90px;
      height: 100%;
      font-size: 12px;
      margin: 0 10px ;
      padding-bottom: 10px 0;
      &:hover{
        border-bottom: 2px solid #008e95;
        cursor: pointer;
      }
    }
  }
  .storefront{
    max-width: 100%;
    min-height: 100%;
    padding: 0;
    height: 100vh;
    &__sheet{
      max-height: calc(100vh - 50px)
    }
  }
  .category-card{
    color: #fff;
    position:relative;
    overflow: hidden;
    border-radius: 5px;
    height: 85px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    p{
      margin:0;

    }
    &__content{
      display: flex;
      flex-direction: column;
      justify-content: center;
      h3{
        line-height: 20px;
      }
      p{
        max-width: 90px !important;
        font-size: 7px !important;
      }
    }
    &__circle{
      z-index: -1;
      border-radius: 50%;
      width: 70px;
      height: 70px;
      position: absolute;
      right:-15px;
      bottom: -15px;
      display: flex;
      color: #fff;
      justify-content:center;
      align-items: center;
    }
    &.category{
      &__nacion{
        background-image: linear-gradient(to right, #009552, #00a955, #00a955, #00c362);
        .category-card__circle{
          background: #009850;
        }
      }
      &__deportes{
        background-image: linear-gradient(to right, #0046a6, #0046a6, #2b6dc7, #2b6dc7);
        .category-card__circle{
          background: #0046a6;
        }
      }
      &__viral{
        background-image: linear-gradient(to right, #de5c0c, #de5c0c, #e57e39, #e57e39);
        .category-card__circle{
          background: #dd5503;
        }
      }
      &__internacional{
        background-image: linear-gradient(to right, #6008ac, #6008ac, #802cc7, #802cc7);
        .category-card__circle{
          background: #56039b;
        }
      }
      &__vivir{
        background-image: linear-gradient(to right, #09a7ad, #09a7ad, #2cc2c7, #2cc2c7);
        .category-card__circle{
          background: #16999e;
        }
      }
      &__tecnologia{
        background-image: linear-gradient(to right, #aaaf0c, #aaaf0c, #c2c72c, #c2c72c);
        .category-card__circle{
          background: #878b06;
        }
      }
      &__eyn{
        background-image: linear-gradient(to right, #63a701, #63a701, #81c225, #81c225);
        .category-card__circle{
          background: #71af19;
        }
      }
      &__entretenimiento{
        background-image: linear-gradient(to right, #ad0988, #ad0988, #c2259f, #c2259f);
        .category-card__circle{
          background: #890c6d;
        }
      }
    }
  }
  .banner-title{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    h1 {
      color: #000;
      font-size: 3rem;

    }
    p{
      color :#000;
      font-size: 1.5rem;

    }
  }
</style>
